import UserFiles from './components/UserFiles';

// eslint-disable-next-line import/prefer-default-export
export { UserFiles };
